import apiService from "./apiService";

const agencyService = {
    async getActiveAgencies(){
        try{
            return (await apiService.get(`agency/get-active-agencies`,{},true)).data;
        }
        catch{
            return [];
        }
    },
}

export default agencyService;